/**
 * Our public R2 buckets and the CDN hosts that serve them. No SDK or env
 * access, so browser code can use it too.
 */
export const R2_PUBLIC_HOSTS = {
  'media.easy-peasy.ai': 'images',
  'videos.easy-peasy.ai': 'videos',
  'files.easy-peasy.ai': 'files',
} as const;

export type R2PublicBucket =
  (typeof R2_PUBLIC_HOSTS)[keyof typeof R2_PUBLIC_HOSTS];

/**
 * `https://videos.easy-peasy.ai/a/b.mp4?v=1` → `{ bucket: 'videos', key: 'a/b.mp4' }`.
 * Null for any other host. The query string is not part of the key.
 */
export function parseR2PublicUrl(
  url: string,
): { bucket: R2PublicBucket; key: string } | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:') return null;
  const bucket = (R2_PUBLIC_HOSTS as Record<string, R2PublicBucket>)[
    parsed.hostname
  ];
  if (!bucket) return null;
  let key: string;
  try {
    key = decodeURIComponent(parsed.pathname.replace(/^\/+/, ''));
  } catch {
    return null;
  }
  if (!key || key.endsWith('/')) return null;
  return { bucket, key };
}

export const isR2PublicUrl = (url: string) => parseR2PublicUrl(url) !== null;
